module.exports = "/_next/static/images/a9866161db969c7645a5084532bcb050-fifa-logo.svg.webp";